module.exports = __webpack_public_path__ + "static/img/KH@3x.01d4bc18.jpg";